import React from "react";
import "./Card.css";
import {Link} from "react-router-dom";

const Card = () => {

    const data = [
        {
            img: "images/Our_customer.png",
            text: "Our Customers",
            link:"/customers"
        },
        {
            img: "images/transfer_money.png",
            text: "Transfer Money",
            link:"/transfer"
        },
        {
            img: "images/Add_money.png",
            text: "Transaction",
            link:"/transaction"
        }
    ]

    return (
        <>
            <div className="card_container">
                <center><h1>Our Services</h1></center>
                <div className="card">
                    {data.map((obj, index) => {
                        return (
                            <>
                                <div className="main_card">
                                    <Link to={obj.link} ><img src={obj.img} key={index} alt="Loading" className="card_image" /></Link>  
                                    <div className="text_container">
                                        <div className="text">{obj.text}</div>
                                    </div>
                                </div>
                            </>
                        )
                    })}
                </div>
            </div>
        </>
    )
}

export default Card;